<template>
    <div class="dynamic-content">
        <div class="row text-center">
            <div class="column small-12 text-center pad-area" style="margin-top:100px;">
                <grid-loader></grid-loader>
            </div>
            <h3>{{message}}</h3>
        </div>
    </div>
</template>
<script>
import GridLoader from "@/components/layout/GridLoader";
export default {
  props: ["message"],
  components: { GridLoader }
};
</script>
<style>
</style>
